import { OverviewWebComponent } from './component/OverviewWebComponent';
import { WEB_COMPONENT_WIDGET_OVERVIEW } from '../webcomponents.constants';

export { OverviewWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_OVERVIEW, OverviewWebComponent);
